// extracted by mini-css-extract-plugin
export default {"tableRow":"WaiveTableRow_tableRow__7XS8d"};